var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPhoneIcon = function SvgPhoneIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#979797",
    d: "M2 6V2.666C2 2.298 2.3 2 2.667 2H6c.368 0 .667.298.667.666v2.667A.667.667 0 0 1 6 6H4.667A5.333 5.333 0 0 0 10 11.333V10c0-.369.299-.667.667-.667h2.667c.368 0 .666.298.666.667v3.333a.667.667 0 0 1-.666.667H10a8 8 0 0 1-8-8"
  })));
};
export default SvgPhoneIcon;